// Centralized portfolio data for content-driven rendering
export const profile = {
  name: "Unais Ali",
  title: "Technical PM & Product | PhD Cybersecurity & Applied Computing | EdTech Founder",
  taglineRoles: [
    "Empowering 20,000+ Students Across 50+ Countries",
    "F6S Top 100 EdTech Platform (#21) | Award-Winning Founder",
    "Creator of 3 No-Code AI Tools | Tested in Michigan Schools",
    "Program Specialist @ University of Michigan | Neurodiversity & EdTech",
    "PhD Student · Cybersecurity & Applied Computing | Starting Fall 2026",
    "MS Engineering Management @ EMU | Graduated · Perfect 4.0 GPA",
    "TRUEMU Certified | University Graduate Scholarship Award Winner",
    "STEM Education Pioneer | Making AI Accessible to Kids",
    "18,000+ LinkedIn Followers | Thought Leader in EdTech",
    "Technical Product Manager | Building the Future of Learning",
    "Global EdTech Founder | Transforming Education Worldwide",
  ],
  location: "Ypsilanti, MI",
  phone: "",
  email: "unais@utech-edu.com",
  avatarUrl:
    "https://drive.google.com/uc?export=download&id=1zrTjMYm10kquAnbbXbBoPyjBWQ4ya8vf",
  social: {
    github: "https://github.com/unaisshazan",
    linkedin: "https://www.linkedin.com/in/unais-ali-a88245176",
    twitter: "",
    website: "https://utech-edu.com",
    email: "mailto:unais@utech-edu.com",
  },
  seo: {
    siteName: "Unais Ali | EdTech Founder, PhD Student & STEM Education Leader",
    description:
      "Unais Ali is the Founder & CEO of UTech Digital Education, empowering 20,000+ students in 50+ countries with AI, Robotics, and STEM education. MS Engineering Management graduate from Eastern Michigan University (4.0 GPA). PhD student in Cybersecurity and Applied Computing starting Fall 2026. Mentor and speaker passionate about making high-tech education accessible globally.",
    ogImage: "/Images/readme-img.png",
    twitterHandle: "@unaisali",
    url: "https://unaisali.com",
    keywords: [
      "Unais Ali", "Unais Ali EdTech", "Unais Ali UTech", "Unais Ali Founder", "Unais Ali CEO",
      "Unais Ali EMU", "Unais Ali Eastern Michigan University", "Unais Ali PhD", "Unais Ali Graduate Student",
      "Unais Ali Engineering Management", "Unais Ali Cybersecurity", "Unais Ali Applied Computing", "Unais Ali 4.0 GPA", "Unais Ali Scholarship",
      "Unais Ali Mentor", "Unais Ali STEM Education", "Unais Ali Pakistan", "Unais Ali Michigan",
      "Unais Ali Technical PM", "Unais Ali Product Manager", "Unais Ali ML Engineer",
      "Unais Ali Portfolio", "Unais Ali Resume", "Unais Ali Blog", "Unais Ali LinkedIn",
      "UTech Digital Education", "UTech Founder", "UTech CEO", "UTech Digital Education Founder",
      "STEM Education", "EdTech Founder", "AI Education", "Robotics Education", "Coding for Kids",
      "Engineering Management EMU", "Cybersecurity PhD", "Applied Computing", "GameAbove College", "TRUEMU", "Digital Zen",
      "F6S Top 100", "Online Learning Platform", "Graduate Assistant EMU",
      "Dare2Design", "STEM Science Festival", "Capstone Projects", "Student Mentorship",
      "Fully Funded Scholarship", "SOP Writing", "F1 Visa", "Study in USA",
      "Technical Product Manager", "Embedded Systems Engineer", "Machine Learning Engineer",
      "IoT Engineer", "React Developer", "Node.js Developer", "PyTorch", "Computer Vision"
    ],
  },
  resume: {
    publicPdfPath: "/resume/Unais-Ali.pdf",
  },
  highlights: [
    "PhD Cybersecurity & Applied Computing @ EMU (Starting Fall 2026 · August)",
    "MS Engineering Management @ EMU (Graduated · Perfect 4.0 GPA)",
    "Founder & CEO of UTech Digital Education · 20,000+ students in 50+ countries",
    "Developed 3 no-code AI tools for kids · Tested in Michigan schools · Trained numerous students",
    "F6S Top 100 Online Learning Platform (#21) · TRUEMU Professional Development Badge",
    "Graduate Assistant @ EMU · Mentored capstone projects · Organized STEM exhibitions",
    "University Graduate Scholarship Award 2025-2026 · Winter Semester Mini Grant recipient",
    "18,000+ LinkedIn followers · Speaker at EMU CEO x SHRM Networking Event",
  ],
  summary:
    "Visionary entrepreneur, educator, and researcher focused on human-centered AI, EdTech, and cybersecurity. Founder & CEO of UTech Digital Education, empowering 20,000+ learners in 50+ countries with AI, Robotics, and STEM education. MS Engineering Management graduate from Eastern Michigan University with a perfect 4.0 GPA. Beginning a PhD in Cybersecurity and Applied Computing in Fall 2026 (August). Graduate Assistant, mentor, and speaker who has organized STEM exhibitions, mentored capstone projects, and received recognition including TRUEMU Professional Development Badge, University Graduate Scholarship Award, and F6S Top 100 Online Learning Platform ranking (#21). Developed 3 no-code AI tools to teach young kids AI and robotics, successfully tested in Michigan schools and trained numerous students. Passionate about making high-tech education accessible globally and helping students achieve fully funded scholarships.",
  quote: "Work hard until you achieve success",
  researchInterests: [
    "Cybersecurity and Applied Computing",
    "Human-Inspired Artificial Intelligence",
    "Embedded and Intelligent Systems",
    "Cognitive Computing and Machine Learning",
    "No-Code AI and Educational Robotics",
    "Neuromorphic and Adaptive System Design",
    "Human–Computer Interaction and Intelligent Automation",
    "Computer Vision and Perception-Based Control",
    "AI for Education and Inclusive Learning",
    "Edge Computing and Energy-Efficient AI",
    "Interdisciplinary AI for Social Impact and STEM Education",
  ],
};


